var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.5833 58.3333H61.2917L60.125 57.2083C64.2083 52.4583 66.6667 46.2917 66.6667 39.5833C66.6667 24.625 54.5417 12.5 39.5833 12.5C24.625 12.5 12.5 24.625 12.5 39.5833C12.5 54.5417 24.625 66.6667 39.5833 66.6667C46.2917 66.6667 52.4583 64.2083 57.2083 60.125L58.3333 61.2917V64.5833L79.1667 85.375L85.375 79.1667L64.5833 58.3333ZM39.5833 58.3333C29.2083 58.3333 20.8333 49.9583 20.8333 39.5833C20.8333 29.2083 29.2083 20.8333 39.5833 20.8333C49.9583 20.8333 58.3333 29.2083 58.3333 39.5833C58.3333 49.9583 49.9583 58.3333 39.5833 58.3333Z",
    fill: "#69BEFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9080577b2749eaebd8f328ffaf8c5498.svg";
export { ForwardRef as ReactComponent };